function formatDateTimeLocal(date) {
    const pad = (value) => String(value).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function retouchExpiryAfterDays(days) {
    const date = new Date();
    date.setDate(date.getDate() + Number(days));
    date.setHours(23, 59, 59, 0);
    return formatDateTimeLocal(date);
}

export function retouchExpiryToInput(expiry) {
    const value = Number(expiry);
    const date = Number.isFinite(value) && value > 0 ? new Date(value * 1000) : new Date(expiry);
    return Number.isNaN(date.getTime()) ? "" : formatDateTimeLocal(date);
}

export function formatRetouchExpiry(expiry) {
    const value = Number(expiry);
    const date = Number.isFinite(value) && value > 0 ? new Date(value * 1000) : new Date(expiry);
    if (Number.isNaN(date.getTime())) return "—";
    const pad = (part) => String(part).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function defaultRetouchExpiry() {
    return retouchExpiryAfterDays(30);
}

export function validateRetouchReviewForm(values, messages = {}) {
    const albumPath = String(values.albumPath || "").trim().replace(/^\/+|\/+$/g, "");
    const albumName = String(values.albumName || "").trim();
    const expiryMs = new Date(values.expiry).getTime();
    if (!albumPath || albumPath.includes("..") || /[\0\r\n\\]/.test(albumPath)) {
        throw new Error(messages.invalidRoot || "请输入有效的 R2 根目录");
    }
    if (!albumName) throw new Error(messages.projectNameRequired || "请输入项目名称");
    if (!Number.isFinite(expiryMs) || expiryMs <= Date.now()) throw new Error(messages.expiryFuture || "过期时间必须晚于现在");
    return { albumPath, albumName, expiry: Math.floor(expiryMs / 1000) };
}
